export default "__VITE_PUBLIC_ASSET__c24b515f__"